<template>
  <div>
    <v-row align="center" style="padding: 30px 20px 5px">
      <v-col class="d-flex" cols="12" sm="6"
        ><b style="margin-left :5px"> رزرو هفتگی: </b>
        {{ reserveBeforeWeekendText }}
      </v-col>

      <v-col class="d-flex" cols="12" sm="6"
        ><b style="margin-left :5px">جریمه خودکار:</b>
        {{ automaticJarimehText }}</v-col
      >
    </v-row>
    <app-history
      v-if="isAdmin"
      @clicked="
        showDialog = true;
        currentSchool = initSchool;
      "
      title="افزودن مدرسه"
    />
    <v-row align="center" style="padding: 10px 20px 10px; font-size: 120%;">
      <v-col class="d-flex" cols="12"
        ><b style="margin-left :5px"> لیست مدارس: </b>
      </v-col>
    </v-row>
    <div>
      <v-data-table
        :items="schools"
        :headers="schoolsHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.isActive`]="{ item }">
          {{ item.isActive ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.kpriceStudent`]="{ item }">
          {{ getItemDesc(item.kpriceStudent) }}
        </template>
        <template v-slot:[`item.kpriceTeacher`]="{ item }">
          {{ getItemDesc(item.kpriceTeacher) }}
        </template>
        <template v-slot:[`item.kpricePersonel`]="{ item }">
          {{ getItemDesc(item.kpricePersonel) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }" v-if="isAdmin">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="removeItem(item)"
            >حذف</v-btn
          >
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> شناسه مدرسه </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentSchool.schoolId"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تعرفه طلاب </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="priceTypes"
            item-text="text"
            item-value="value"
            v-model="currentSchool.kpriceStudent"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تعرفه اساتید </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="priceTypes"
            item-text="text"
            item-value="value"
            v-model="currentSchool.kpriceTeacher"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تعرفه پرسنل </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="priceTypes"
            item-text="text"
            item-value="value"
            v-model="currentSchool.kpricePersonel"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> مبلغ بدهی مجاز </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentSchool.mablaqBedehkariMojaz"
            maxlength="12"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="10"> فعال </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentSchool.isActive"></v-switch>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetBranchInfo } from "@/api/branch";
import { SaveSchool, DeleteSchool } from "@/api/orderschools";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      schools: [],
      automaticJarimehText: "",
      reserveBeforeWeekendText: "",
      priceTypes: [
        { value: 1, text: "طلبه" },
        { value: 2, text: "استاد" },
        { value: 3, text: "پرسنل" },
        { value: 4, text: "آزاد" },
        { value: 5, text: "سایر" },
      ],
      currentSchool: {},
      initSchool: {
        schoolId: 0,
        kpriceStudent: 1,
        kpriceTeacher: 2,
        kpricePersonel: 3,
        isActive: true,
        mablaqBedehkariMojaz: 10000,

        id: "0",
      },
      isEdit: false,

      schoolsHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "شناسه مدرسه",
          value: "schoolId",
          width: "10%",
          sortable: false,
        },

        {
          text: "تعرفه طلاب",
          value: "kpriceStudent",
          width: "10%",
        },
        {
          text: "تعرفه اساتید",
          value: "kpriceTeacher",
          width: "10%",
        },
        {
          text: "تعرفه پرسنل",
          value: "kpricePersonel",
          width: "10%",
        },
        {
          text: "مبلغ بدهی مجاز",
          value: "mablaqBedehkariMojaz",
          width: "10%",
        },
        {
          text: "فعال",
          value: "isActive",
          width: "10",
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.currentSchool = this.initSchool;
    if (this.currentBranch) this.GetBranchInfo();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },

  methods: {
    GetBranchInfo() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchInfo(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.schools = response.data.orderSchools;
            this.automaticJarimehText = response.data.automaticJarimeh
              ? "بله"
              : "خیر";
            this.reserveBeforeWeekendText = response.data.reserveBeforeWeekend
              ? "بله"
              : "خیر";

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getItemDesc(kprice) {
      switch (kprice) {
        case 1:
          return "طلبه";
        case 2:
          return "استاد";
        case 3:
          return "پرسنل";
        case 4:
          return "آزاد";
        case 5:
          return "سایر";
      }
    },

    editItem(item) {
      this.currentSchool = Object.assign({}, item);
      this.showDialog = true;
      this.isEdit = true;
    },
    removeItem(item) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", item.id);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این مدرسه هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";

      if (this.currentSchool.schoolId == 0) {
        text = "مدرسه بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SaveSchool(
          this.currentSchool.id,
          this.currentBranch.id,
          this.currentSchool.schoolId,
          this.currentSchool.mablaqBedehkariMojaz,
          this.currentSchool.kpriceStudent,
          this.currentSchool.kpriceTeacher,
          this.currentSchool.kpricePersonel,
          this.currentSchool.isActive
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetBranchInfo();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        DeleteSchool(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetBranchInfo();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
